<template>
  <gat-grid :items="items" />
</template>

<script>
export default {
  name: 'debugGatGridItems',
  props: [],
  components: {},
  data() {
    return {
      items: [],
    };
  },

  created() {},

  watch: {},

  methods: {},
};
</script>

<style scoped></style>
